module.exports = __webpack_public_path__ + "static/media/dmsans-regular-webfont.205436f0.woff2";